import React, { useState, useEffect } from 'react';
import { List, ListItem, ListItemText, Typography, CircularProgress, Alert, Link } from '@mui/material';

function NewsFeed({ query }) {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get the current year
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    if (!query) return;

    const fetchNews = async () => {
      setLoading(true);
      setError(null);

      // SAFEGUARD: Automatically replace "2025" (or any old year) in the search query with the current year
      // This ensures you always fetch this year's news, even if the parent component sends "2025"
      const dynamicQuery = query.replace(/2025/g, currentYear.toString());

      // Point to your custom server endpoint which fetches from Google RSS
      const url = `https://api.christmas.termplanner.com.au/api/news?q=${encodeURIComponent(dynamicQuery)}`;

      try {
        const response = await fetch(url);
        const data = await response.json();
        
        if (data.status === 'error') throw new Error(data.message);
        
        // Take only the top 5 articles
        setArticles(data.articles.slice(0, 5));
      } catch (err) {
        setError("Could not fetch news. " + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [query, currentYear]); // Added currentYear to the dependency array

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="warning">News currently unavailable.</Alert>;
  if (articles.length === 0) return <Typography>No recent news found for "{query}".</Typography>;

  return (
    <List>
      {articles.map((article, index) => (
        <ListItem key={index} divider alignItems="flex-start">
          <ListItemText
            primary={
              <Link href={article.link} target="_blank" rel="noopener noreferrer" underline="hover">
                {article.title}
              </Link>
            }
            secondary={
              <>
                <Typography component="span" variant="body2" color="text.primary">
                  {new Date(article.pubDate).toLocaleDateString()} — {article.source}
                </Typography>
              </>
            }
          />
        </ListItem>
      ))}
    </List>
  );
}

export default NewsFeed;